import Vue from "vue";
import { en } from "vuejs-datepicker/src/locale";
import devData from "./data-dev";

export default Vue.observable({
  showDate: new Date(),
  disabledFrom: false,
  id: 0,
  title: '',
  startDate: '',
  endDate: '',
  labelLocal: 'none',
  currentViewEvent: {
    id: 0,
    title: '',
    startDate: '',
    endDate: '',
    labelLocal: 'none',
    data: {},
  },
  langEn: en,

  url: '',
  calendarView: 'month',

  activePromptAddEvent: false,
  activePromptEditEvent: false,
  activeViewEvent: false,

  calendarViewTypes: [
    {
      label: "Week",
      i18n: "general.time.week",
      val: "week"
    },
    {
      label: "Month",
      i18n: "general.time.month",
      val: "month"
    },
    {
      label: "Year",
      i18n: "general.time.year",
      val: "year"
    },
  ],
  calendarEvents: [ ...devData.events ],
  chatroom: {
    active: false,
    chatId: null,
    chatActivator: null,
  }
});
